/** @format */

import axios from 'axios';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BaseUrl, getAuthHeaders } from '../components/BaseURl/BaseUrl';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const [date, time] = dateString?.split('T');
  const [hour, minute] = time?.split(':');

  const d = new Date(`${date}T00:00:00`);

  return `${d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })} ${hour}:${minute}`;
};

const formatDateTimeP = (utcString) => {
  if (!utcString) return '';

  const date = new Date(utcString);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  return formatter.format(date);
};



const uploadImage = async (file, url, options = {}) => {
  const { setLoading, setResponse, successMsg, errorMsg, additionalFunctions = [] } = options;

  if (setLoading) setLoading(true);

  try {
    const formData = new FormData();
    formData.append('image', file);

    const response = await axios.post(`${BaseUrl}${url}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...getAuthHeaders(),
      },
    });

    if (setResponse) setResponse(response.data);

    // Show success message
    if (successMsg) toast.success(successMsg);

    // Run additional functions
    additionalFunctions.forEach(
      (func) => func && typeof func === 'function' && func(response?.data)
    );
  } catch (error) {
    const msg = error?.response?.data?.message || errorMsg;
    toast.error(msg);
  } finally {
    if (setLoading) setLoading(false);
  }
};

const formatDate = (dateString) => {
  const date = new Date(dateString);

  // Ensure day and month are two digits
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  return formattedDate;
};
const formatDate1 = (dateString) => {
  const date = new Date(dateString);

  // Ensure day and month are two digits
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

const getFormattedTime = (timestamp) => {
  let date;

  if (timestamp && typeof timestamp.toMillis === 'function') {
    date = new Date(timestamp.toMillis());
  } else if (timestamp instanceof Date) {
    date = timestamp;
  } else if (typeof timestamp === 'string') {
    date = new Date(timestamp);
  } else {
    console.error('Invalid timestamp:', timestamp);
    return 'Invalid Time';
  }

  if (isNaN(date.getTime())) {
    console.error('Invalid date:', date);
    return 'Invalid Time';
  }

  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;

  return `${displayHours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')} ${period}`;
};

// Order times are stored as IST wall-clock values with a Z suffix (same as mobile app).
const toOrderDateTime = (date, time) => `${date}T${time}:00.000Z`;

const addMinutesToOrderDateTime = (dateTimeIso, minutes) => {
  const date = new Date(dateTimeIso);
  date.setUTCMinutes(date.getUTCMinutes() + minutes);
  return date.toISOString();
};

const getOrderTimeFromDateTime = dateTimeIso => dateTimeIso?.split('T')[1]?.slice(0, 5) || '';

const getOrderFormattedTime = (timestamp) => {
  let date;

  if (timestamp && typeof timestamp.toMillis === 'function') {
    date = new Date(timestamp.toMillis());
  } else if (timestamp instanceof Date) {
    date = timestamp;
  } else if (typeof timestamp === 'string') {
    date = new Date(timestamp);
  } else {
    return 'Invalid Time';
  }

  if (isNaN(date.getTime())) {
    return 'Invalid Time';
  }

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date);

  const hours = parts.find(p => p.type === 'hour')?.value ?? '12';
  const minutes = parts.find(p => p.type === 'minute')?.value ?? '00';
  const period = (parts.find(p => p.type === 'dayPeriod')?.value ?? 'AM').toUpperCase();

  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')} ${period}`;
};

const isToday2 = (date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

const isYesterday2 = (date) => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  );
};

const formatDatemessage = (date) => {
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export {
  addMinutesToOrderDateTime,
  formatDate,
  formatDate1,
  formatDatemessage,
  formatDateTime,
  getFormattedTime,
  getOrderFormattedTime,
  getOrderTimeFromDateTime,
  isToday2,
  isYesterday2,
  ScrollToTop,
  toOrderDateTime,
  uploadImage,
  formatDateTimeP,
};
